import React from "react";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { useFetchUpcomingWeddings } from "../../redux/api/WeddingAPI";
import { Wrapper } from "./component";
import WeddingAlbumCard from "../WeddingCard/WeddingAlbumCard";
import { PageLoading } from "../Loading/Loading";
import { useMediaQuery } from "react-responsive";

const ChooseWeddingList = ({
	showModal,
	setShowModal = () => {
		return null;
	},
	setWeddingDetails = () => {
		return null;
	},
}) => {
	const isMobile = useMediaQuery({ maxWidth: 1217 });
	const { data: upcomingWeddings, isLoading: upcomingLoading } =
		useFetchUpcomingWeddings();

	const weddings = upcomingWeddings?.weddings;
	// console.log(weddings, "upcoming weddings");

	return (
		<Wrapper>
			<Modal
				footer=""
				visible={showModal}
				centered
				width={isMobile ? "100%" : "75%"}
				closable={false}
				maskClosable={false}>
				<div
					tw="h-8 w-8 px-2 py-2 bg-gray-100! rounded-full hover:(cursor-pointer border-2 border-solid border-purple-800) flex items-center justify-center"
					onClick={() => setShowModal(false)}>
					<ArrowLeftOutlined
						tw="hover:(text-purple-800 transform scale-125)"
						style={{ zIndex: 50000000 }}
					/>
				</div>

				<h3 tw="font-bold text-center text-lg opacity-90 leading-8 tracking-wide">
					Choose a wedding from
				</h3>

				<div tw="mt-4 flex flex-row flex-wrap gap-4 ">
					{weddings?.map((wedding, i) => {
						return (
							<WeddingAlbumCard
								key={i}
								details={wedding}
								handleClick={() => {
									setShowModal(false);
									setWeddingDetails(wedding)
								}}
							/>
						);
					})}
				</div>
				{upcomingLoading && (
					<div style={{ height: "50vh" }}>
						<PageLoading />
					</div>
				)}
			</Modal>
		</Wrapper>
	);
};

export default ChooseWeddingList;
